export default "__VITE_ASSET__DlmjEQTp__"